import { jsx, jsxs } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import React__default from "react";
import { P as PropTypes, t as tagPropType, m as mapToCssModules } from "../../../../utils-65a8d69b.js";
import { F as Fade } from "../../../../Fade-5a502c0e.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import "../../../../styles/assets/images/icons/material/designSystem/Add.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettings.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Analytics.js";
import "../../../../styles/assets/images/icons/material/designSystem/AnalyticsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apartment.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apps.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowBack.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropDown.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropUp.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowForward.js";
import "../../../../styles/assets/images/icons/material/designSystem/Bolt.js";
import "../../../../styles/assets/images/icons/material/designSystem/BoltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/BugReport.js";
import "../../../../styles/assets/images/icons/material/designSystem/CalendarTodayFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Cancel.js";
import "../../../../styles/assets/images/icons/material/designSystem/CancelFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/Circle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CircleFilled.js";
import { ReactComponent as ForwardRef } from "../../../../styles/assets/images/icons/material/designSystem/Close.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumber.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumberFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupport.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupportFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCard.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Dashboard.js";
import "../../../../styles/assets/images/icons/material/designSystem/DashboardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Delete.js";
import "../../../../styles/assets/images/icons/material/designSystem/DeleteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Edit.js";
import "../../../../styles/assets/images/icons/material/designSystem/EditFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Error.js";
import "../../../../styles/assets/images/icons/material/designSystem/ErrorFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/EventFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandContent.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandLess.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandMore.js";
import "../../../../styles/assets/images/icons/material/designSystem/Favorite.js";
import "../../../../styles/assets/images/icons/material/designSystem/FavoriteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FirstPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/Forward.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHome.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Group.js";
import "../../../../styles/assets/images/icons/material/designSystem/GroupFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Home.js";
import "../../../../styles/assets/images/icons/material/designSystem/HomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Info.js";
import "../../../../styles/assets/images/icons/material/designSystem/InfoFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/LastPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAlt.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Logout.js";
import "../../../../styles/assets/images/icons/material/designSystem/Mail.js";
import "../../../../styles/assets/images/icons/material/designSystem/MailFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Menu.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeart.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeartFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/MoreVert.js";
import "../../../../styles/assets/images/icons/material/designSystem/Notifications.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Pending.js";
import "../../../../styles/assets/images/icons/material/designSystem/Person.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChange.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChangeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPin.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPinFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Refresh.js";
import "../../../../styles/assets/images/icons/material/designSystem/Reply.js";
import "../../../../styles/assets/images/icons/material/designSystem/Route.js";
import "../../../../styles/assets/images/icons/material/designSystem/Schedule.js";
import "../../../../styles/assets/images/icons/material/designSystem/Search.js";
import "../../../../styles/assets/images/icons/material/designSystem/Settings.js";
import "../../../../styles/assets/images/icons/material/designSystem/SettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Shield.js";
import "../../../../styles/assets/images/icons/material/designSystem/ShieldFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Smartphone.js";
import "../../../../styles/assets/images/icons/material/designSystem/SmartphoneFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Tune.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityOffFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Warning.js";
import "../../../../styles/assets/images/icons/material/designSystem/WarningFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Work.js";
import "../../../../styles/assets/images/icons/material/designSystem/WorkFilled.js";
import "../../../../styles/assets/images/icons/brands/GoogleG.js";
import { sass } from "../../../../sass/sass.js";
import FlashButton from "../../buttons/FlashButton/FlashButton.js";
import { FlashInfoMessageType } from "../constants.js";
import { getMessageIcon } from "../utils.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "../../../../Transition-a28a969d.js";
import "react-dom";
import "../FlashBadge/FlashBadge.js";
import "../FlashSpinner/FlashSpinner.js";
import "../../buttons/FlashButtonGeneric.js";
import "../../../../index-5e4e4f4b.js";
import "../../../../axios-5f69b112.js";
import "../../../../Button-dadda608.js";
import "../../../../hooks/useInsights/useInsights.js";
import "../../../../utils/noOp.js";
import "../../../../hooks/useLogger/constants.js";
import "../../../../hooks/useLogger/useLogger.js";
import "../../../../hooks/useLogger/LoggerContext.js";
import "../../../../hooks/useLogger/types.js";
import "../../../../hooks/useInsights/InsightsContext.js";
import "../../../../hooks/useInsights/useInsightsImpression.js";
import "../../../../index-2d889c01.js";
import "../../../../hooks/useInsights/utils.js";
import "../../../../utils/invokeFn.js";
import "../../buttons/FlashButton/constants.js";
var _excluded$1 = ["className", "cssModule", "tag", "isOpen", "children", "transition", "fade", "innerRef"];
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$1.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, { value, enumerable: !0, configurable: !0, writable: !0 }) : obj[key] = value, obj;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
var propTypes$1 = {
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  fade: PropTypes.bool,
  isOpen: PropTypes.bool,
  tag: tagPropType,
  transition: PropTypes.shape(Fade.propTypes),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
};
function Toast(props) {
  var className = props.className, cssModule = props.cssModule, _props$tag = props.tag, Tag = _props$tag === void 0 ? "div" : _props$tag, _props$isOpen = props.isOpen, isOpen = _props$isOpen === void 0 ? !0 : _props$isOpen, children = props.children, _props$transition = props.transition, transition = _props$transition === void 0 ? _objectSpread(_objectSpread({}, Fade.defaultProps), {}, {
    unmountOnExit: !0
  }) : _props$transition, _props$fade = props.fade, fade = _props$fade === void 0 ? !0 : _props$fade, innerRef = props.innerRef, attributes = _objectWithoutProperties$1(props, _excluded$1), classes = mapToCssModules(classNames(className, "toast"), cssModule), toastTransition = _objectSpread(_objectSpread(_objectSpread({}, Fade.defaultProps), transition), {}, {
    baseClass: fade ? transition.baseClass : "",
    timeout: fade ? transition.timeout : 0
  });
  return /* @__PURE__ */ React__default.createElement(Fade, _extends$1({}, attributes, toastTransition, {
    tag: Tag,
    className: classes,
    in: isOpen,
    role: "alert",
    innerRef
  }), children);
}
Toast.propTypes = propTypes$1;
var _excluded = ["className", "cssModule", "innerRef", "tag"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
var propTypes = {
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func])
};
function ToastBody(props) {
  var className = props.className, cssModule = props.cssModule, innerRef = props.innerRef, _props$tag = props.tag, Tag = _props$tag === void 0 ? "div" : _props$tag, attributes = _objectWithoutProperties(props, _excluded), classes = mapToCssModules(classNames(className, "toast-body"), cssModule);
  return /* @__PURE__ */ React__default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
}
ToastBody.propTypes = propTypes;
function FlashToast(props) {
  const { toastId, type = FlashInfoMessageType.info, title, children, onClose, className, isExpired } = props, ToastIcon = getMessageIcon(type), toastOnClose = onClose ? () => {
    onClose(toastId);
  } : void 0;
  return /* @__PURE__ */ jsx("div", { className: `${COMMON_CLASSNAME} flash-toast`, children: /* @__PURE__ */ jsx(
    Toast,
    {
      className: classNames(`border-${type}`, { "fade-in": !isExpired, "fade-out": isExpired }, className),
      fade: !1,
      children: /* @__PURE__ */ jsxs(ToastBody, { children: [
        /* @__PURE__ */ jsxs("div", { className: "d-flex justify-content-between", children: [
          /* @__PURE__ */ jsx("div", { className: "d-flex ", children: title && /* @__PURE__ */ jsxs("span", { "data-testid": `${toastId}-header`, children: [
            ToastIcon && /* @__PURE__ */ jsx("span", { className: classNames(`icon-${type}`, "me-flash-100"), children: /* @__PURE__ */ jsx(
              ToastIcon,
              {
                height: sass.typography.flash.semantic.font.heading.l.size,
                width: sass.typography.flash.semantic.font.heading.l.size
              }
            ) }),
            /* @__PURE__ */ jsx("span", { className: `text-${type} fw-bold`, children: title })
          ] }) }),
          onClose && /* @__PURE__ */ jsx(
            FlashButton,
            {
              id: `${toastId}-close-btn`,
              onClick: toastOnClose,
              color: "icon_only_default",
              LeadingIcon: ForwardRef,
              removePadding: !0,
              className: "ms-flash-150 mt-nflash-050"
            }
          )
        ] }),
        children && /* @__PURE__ */ jsx("div", { className: "ms-flash-300 mt-flash-050", children })
      ] })
    }
  ) });
}
export {
  FlashToast as default
};
//# sourceMappingURL=FlashToast.js.map
